<template>
  <page :title="i18n.wallet" :showBack="false">
    <!-- 替换为自定义类名 -->
    <div class="wallet-pending-card">
      <!-- 第1行：状态 -->
      <div class="wallet-pending-header">
        <span class="wallet-pending-label">Balance to be paid</span>
        <div class="wallet-pending-status">
          <div class="wallet-status-dot"></div>
          <span class="wallet-status-text">Inactive</span>
        </div>
      </div>

      <!-- 第2行：留白 -->
      <div class="wallet-pending-spacer"></div>

      <!-- 第3行：金额 -->
      <div class="wallet-pending-amount">
        <p class="wallet-amount-text">DH {{ pendingPayment.toFixed(2) }}</p>
      </div>

      <!-- 底部 -->
<!--      <div class="wallet-pending-footer">-->
<!--        <p class="wallet-footer-text">Your subscription</p>-->
<!--      </div>-->
    </div>
  </page>
</template>

<script>
import { USER_INFO, USER_WALLET, ORDER_LIST } from '../../apis/user.js'
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState(['user', 'cabinet']),
    i18n () {
      return this.$t('mine')
    },
    i18nMsg () {
      return this.$t('msg')
    },
    // walletlist () {
    //   return this.list.filter(item => {
    //     return item.pBalance > 0
    //   })
    // },
    agentOpenId () {
      if (this.cabinet && this.cabinet.userWallet) {
        return this.cabinet.userWallet.pDailiId
      } else {
        return ''
      }
    }
  },
  data () {
    return {
      list: [],
      // list: [{
      //   pbalance: 1,
      //   pId: 1,
      //   pdepositAmount: 1,
      //   pcurrencySymbol: '$'
      // }, {
      //   pbalance: 2,
      //   pId: 2,
      //   pdepositAmount: 2,
      //   pcurrencySymbol: '$'
      // }],
      selected: null,
      query: null,
      pendingPayment: 0.00,
      querypath: window.location.href.split('?')[1]
    }
  },
  methods: {
    selectedItem (e) {
      console.log(JSON.parse(e.target.dataset.item))
      let selecteddata = JSON.parse(e.target.dataset.item)
      if (this.selected && selecteddata.pDailiId === this.selected.pDailiId && selecteddata.pCurrencyType === this.selected.pCurrencyType) {
        this.selected = null
        this.$store.commit('wallet', null)
        return
      }
      this.$store.commit('wallet', selecteddata)
      this.selected = selecteddata
    },
    loadUser () {
      this.$loading(true)
      this.$get(
        USER_INFO,
        {},
        resp => {
          this.$loading(false)
          if (resp.user) {
            this.$store.commit('user', resp.user)
            this.getMineOrders()
          } else {
            this.$confirm({
              title: this.i18n.msg_fail_title,
              content: this.i18n.msg_fail_user,
              confirmText: this.i18nMsg.retry,
              cancelText: this.i18nMsg.cancel
            }).then(() => {
              this.loadUser()
            })
          }
        },
        error => {
          this.$loading(false)
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: this.i18nMsg.error,
            confirmText: this.i18nMsg.retry,
            cancelText: this.i18nMsg.cancel
          }).then(() => {
            this.loadUser()
          })
          console.log(error)
        }
      )
    },
    goRouter (path) {
      this.$router.push(path)
    },
    getMineOrders() {
      this.$loading(true)
      this.$get(
        ORDER_LIST,
        {
          page: 1,
          pageSize: 10
        },
        resp => {
          this.$loading(false)
          this.list = resp.data
          if (this.list && this.list.length > 0) {
            this.pendingPayment = 0.00;
            this.list.forEach(element => {
              if (element != null) {
                if ((element.status === 3 || element.status === 5) && (element.settledAmount < element.total)) {
                  this.pendingPayment = element.total - element.settledAmount;
                }
              }
            });
          }
        },
        error => {
          this.$loading(false)
          console.log(error)
        }
      )
    }
  },
  created () {
    this.query = this.$route.query
    this.loadUser()
  }
}
</script>

<style lang="less">
.selected{
  border: solid 2px #309df7;
  border-top: solid 2px #309df7!important;
}
.Mask{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
}
.wallet-balance{
  position: relative;
  margin: 40px;
  // background: linear-gradient(90deg,#EBD460 0%,#E5BE53 100%);
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  padding: 40px 60px 20px;
  color: #333333;
  display: flex;
  align-items: center;
  &-warp{
    flex: 1;
  }
  &-label{
    font-size: 32px;
  }
  &-value{
    font-size: 70px;
    font-weight: bold;
  }
  &-more{
    & img{
      width: 20px;
      height: 30px;
      display: block;
    }
  }
}
.wallet-btn{
  display: flex;
  padding: 20px 40px;
  & div{
    flex: 1;
    height: 72px;
    line-height: 72px;
    border-radius: 10px;
    text-align: center;
    border: 2px solid #333333;
    font-size: 28px;
    font-weight: 500;
    color: #333333;
    margin: 0 14px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  & img{
    width: 40px;
    height: 40px;
    display: block;
  }
  & span{
    padding-left: 15px;
  }
}
.wallet-pending-card {
  margin: 0 20px;
  margin-top: 24px;
  border-radius: 16px;
  background: linear-gradient(90deg, #00E89F 0%, #58D8EF 100%); // 青→蓝绿渐变
  padding: 20px;
  color: #000;
}

.wallet-pending-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.wallet-pending-label,
.wallet-status-text {
  font-size: 12pt;
  color: black;
  font-weight: bold;
}
.wallet-pending-status {
  display: flex;
  align-items: center;
  gap: 4px; /* 统一控制红点与文字间距 */
}
.wallet-status-dot {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background-color: #ED9F8E; // 红色
  flex-shrink: 0;
}

.wallet-pending-spacer {
  height: 24px; // 确保第3行为独立视觉行
}

.wallet-pending-amount {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  padding-bottom: 50px;
}

.wallet-amount-text {
  font-size: 25pt;
  font-weight: bold;
  margin: 0;
}

.wallet-pending-footer {
  padding-top: 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.3);
  margin-top: 16px;
}

.wallet-footer-text {
  font-size: 13pt;
  color: black;
  text-align: center;
  margin: 0;
}

</style>
